<p class="loader-container">
  <span *ngIf="!loadingFinished">
    <span class="loader"></span>
    <span *ngIf="!verboseMode">Loading variants...</span>
  </span>
  <span *ngIf="loadingFinished || verboseMode" id="variants-count-span">
    <span>{{ count }}</span>
  </span>
</p>
